import { configureStore } from '@reduxjs/toolkit'

import obrasReducer from './reducers/obras'

const store = configureStore({
  reducer: {
    obras: obrasReducer
  }
})

export type RootReducer = ReturnType<typeof store.getState>

export default store
